export function updateCompetitionsState(state, payload) {
    state[payload.state] = payload.data;
  }
  